import { Badge } from "@/components/ui/badge";
import { SelectInput } from "@/components/admin/select-input";
import {
  GROUP_ENTITIES,
  GROUP_ENTITY_CHOICES,
  type GroupEntity,
  type GroupEntityId,
} from "../types";

export function getGroupEntity(id?: string | null): GroupEntity {
  if (id && id in GROUP_ENTITIES) {
    return GROUP_ENTITIES[id as GroupEntityId];
  }
  return GROUP_ENTITIES.five_lens;
}

export function GroupEntityBadge({
  entityId,
  className,
}: {
  entityId?: string | null;
  className?: string;
}) {
  const entity = getGroupEntity(entityId);

  let colorClasses =
    "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/40 dark:text-indigo-300 dark:border-indigo-800";
  if (entity.id === "learn_smartly") {
    colorClasses =
      "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800";
  } else if (entity.id === "ennea_world") {
    colorClasses =
      "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800";
  }

  return (
    <Badge
      variant="outline"
      className={`text-[10px] font-semibold py-0.5 px-2 border ${colorClasses} ${className || ""}`}
      title={`${entity.name} (${entity.domain}) — ${entity.tagline}`}
    >
      {entity.badge}
    </Badge>
  );
}

export function GroupEntitySelect({
  source = "group_entity",
  label = "Ennea Group Entity",
  helperText,
}: {
  source?: string;
  label?: string;
  helperText?: string | false;
}) {
  return (
    <SelectInput
      source={source}
      label={label}
      choices={GROUP_ENTITY_CHOICES}
      defaultValue="five_lens"
      helperText={helperText ?? "Select which group brand is leading this relationship"}
    />
  );
}
